<template>
    <div>
        <custom-tooltip-container :open-by-default="true">
            <template #tooltipTarget v-if="badgeValue > 0">
                <div class="ob1-link-icon ps-1" data-testid="cart-recovery-tooltip-target">
                    <span
                        class="icon icon-buy"
                        style="font-size: 40px"
                        aria-hidden="true"
                    />
                    <span
                        class="ob1-badge ob1-badge-negative ob1-badge-large"
                        style="margin-left: -10px; margin-top: -40px;"
                        v-text="badgeValue"
                    ></span>
                    <span class="visually-hidden">articles dans votre panier</span>
                </div>
            </template>
            <template #tooltipContent>
                <div data-testid="cart-recovery-tooltip-content">
                    <div class="d-flex flex-column p-1">
                        <strong class="mb-2 font-size-16" v-text="title" />
                        <span
                            v-for="(item, idx) in content"
                            :key="idx"
                            class="mb-1 d-block"
                        >
                            {{ item }}
                        </span>
                        <div class="text-center">
                            <ob1-boutons
                                class="px-1 px-md-2 mt-1 mt-lg-0"
                                :is-button="false"
                                :is-primary="true"
                                :label="ctaLabel"
                                :href="ctaUrl"
                                :data-oevent-category="'reprise_panier'"
                                :data-oevent-action="ctaLabel"
                                :data-oevent-label="content"
                            />
                        </div>
                    </div>
                </div>
            </template>
        </custom-tooltip-container>
    </div>
</template>

<script>

import CustomTooltipContainer from "./CustomTooltipContainer.vue";

export default {
    name: "DigitalCartTooltip",
    components: {
        CustomTooltipContainer
    },
    props: {
        title: { type: String, required: true },
        content: { type: Array, required: true },
        ctaLabel: { type: String, required: true },
        ctaUrl: { type: String, required: true },
    },
    computed: {
        badgeValue() {
            return this.content?.length;
        }
    }
}
</script>

<style scoped lang="scss">
.ob1-link-icon .icon::before {
    font-size: inherit;
}
</style>
